<!--
 * @Copyright: 网易集成平台
 * @Author: xiaowenwen
 * @Date: 2021-12-17 09:57:14
 * @LastEditTime: 2022-05-06 11:43:25
 * @Description: 邮件账号列表
-->
<template>
  <general-layout>
    <template #header>
      <east-operate>
        <template #left>
          <el-button
            size="small"
            type="primary"
            @click="CreateReport"
            :disabled="downloading"
          >
            生成列表
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="exportExcel"
            :disabled="downloading"
          >
            导出列表
          </el-button>
        </template>
        <template #right>
          <el-date-picker
            v-model="time"
            @change="fetchData"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="mini"
          >
          </el-date-picker>
          <el-select
            v-model="state"
            @change="currentPage = 1"
            size="mini"
            style="width: 104px;margin-left:7px;"
          >
            <el-option value="" label="所有状态"></el-option>
            <el-option value="正常" label="正常"></el-option>
            <el-option value="已禁用" label="已禁用"></el-option>
            <el-option value="已删除" label="已删除"></el-option>
          </el-select>
          <el-select
            v-model="createType"
            @change="currentPage = 1"
            size="mini"
            style="width: 104px;margin-left:7px;"
          >
            <el-option value="" label="创建方式"></el-option>
            <el-option value="中间件" label="中间件"></el-option>
            <el-option value="其他" label="其他"></el-option>
          </el-select>
          <el-input
            placeholder="请输入邮箱/姓名关键字"
            size="mini"
            v-model="keyword"
            clearable
          >
            <el-input
              size="small"
              class="input-keyword"
              v-model="keyword"
              placeholder="查找邮箱"
              :spellcheck="false"
              autocomplete="off"
              @input="currentPage = 1"
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              title="搜索邮箱"
              @click="fetchData"
              slot="append"
            ></el-button>
          </el-input>
        </template>
      </east-operate>
    </template>
    <el-table :empty-text="emptyText" :data="tableData" v-loading="loading">
      <el-table-column
        prop="mail"
        label="邮箱"
        width="230"
        sortable
      ></el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="200"
        sortable
      ></el-table-column>
      <el-table-column
        prop="unitname"
        label="部门"
        min-width="300"
      ></el-table-column>
      <el-table-column
        prop="unitid"
        label="部门编号"
        width="100"
      ></el-table-column>
      <el-table-column prop="state" label="状态" width="140" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.state === 0">正常</span>
          <span v-else-if="scope.row.state === 1">已禁用</span>
          <span v-else-if="scope.row.state === 2">已删除</span>
          <span v-else>{{ scope.row.state }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200" sortable
        ><template slot-scope="scope">
          {{ scope.row.createTime | dateFormat }}
        </template></el-table-column
      >
      <el-table-column
        prop="createType"
        label="创建方式"
        width="100"
      ></el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleView(scope.row)"
            >明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="allData.length"
      >
      </el-pagination>
    </template>
    <!-- 明细 开始 -->
    <el-dialog
      custom-class="custom-dialog"
      title="账号明细"
      :visible.sync="viewShow"
    >
      <div class="dialog-main-box">
        <table>
          <tr>
            <td>邮箱账号：</td>
            <td>
              {{ viewData.mail }} [{{ viewData.createTime | dateFormat }}]
              [密码最后修改时间:{{ viewData.passchangeTime | dateFormat }}]
            </td>
          </tr>
          <tr>
            <td>账号部门：</td>
            <td>
              {{ viewData.unitname }}
            </td>
          </tr>
        </table>
      </div>
    </el-dialog>
    <!-- 明细 结束 -->
  </general-layout>
</template>
<script>
import Emaillist from "@/api/emaillist";
import UTIL from "@/api/sync/util";
export default {
  name: "app",
  data() {
    return {
      config: { accountlist: [] },
      editLabelWidth: "70px",
      keyword: "",
      state: "",
      time: ["", ""],
      createType: "",
      pageSize: 50,
      currentPage: 1,
      downloading: false,
      mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      action: process.env.VUE_APP_API_URL + "parseexcel",
      viewShow: false,
      viewData: {},
      emptyText: "暂无数据! ",
      loading: false
    };
  },
  computed: {
    allData() {
      //console.log("this.state:" + this.state);
      //console.log("this.time:" + this.time + "this.time[0]:" + this.time[0]);
      if (
        this.time[0] != "" &&
        this.time[1] != "" &&
        this.state == "" &&
        this.createType == ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            (maillist.mail.includes(this.keyword) ||
              maillist.name.includes(this.keyword) ||
              maillist.unitname.includes(this.keyword)) &&
            maillist.createTime >= this.time[0] &&
            maillist.createTime <= this.time[1]
        );
      } else if (
        this.state != "" &&
        this.time[0] == "" &&
        this.time[1] == "" &&
        this.createType == ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            (maillist.mail.includes(this.keyword) ||
              maillist.name.includes(this.keyword) ||
              maillist.unitname.includes(this.keyword)) &&
            maillist.statemsg == this.state
        );
      } else if (
        this.time[0] != "" &&
        this.time[1] != "" &&
        this.state != "" &&
        this.createType == ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            (maillist.mail.includes(this.keyword) ||
              maillist.name.includes(this.keyword) ||
              maillist.unitname.includes(this.keyword)) &&
            maillist.statemsg == this.state &&
            maillist.createTime >= this.time[0] &&
            maillist.createTime <= this.time[1]
        );
      } else if (
        this.time[0] == "" &&
        this.time[1] == "" &&
        this.state != "" &&
        this.createType != ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            (maillist.mail.includes(this.keyword) ||
              maillist.name.includes(this.keyword) ||
              maillist.unitname.includes(this.keyword)) &&
            maillist.statemsg == this.state &&
            maillist.createType == this.createType
        );
      } else if (
        this.time[0] == "" &&
        this.time[1] == "" &&
        this.state == "" &&
        this.createType != ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            (maillist.mail.includes(this.keyword) ||
              maillist.name.includes(this.keyword) ||
              maillist.unitname.includes(this.keyword)) &&
            maillist.createType == this.createType
        );
      } else if (
        this.time[0] != "" &&
        this.time[1] != "" &&
        this.state != "" &&
        this.createType != ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            (maillist.mail.includes(this.keyword) ||
              maillist.name.includes(this.keyword) ||
              maillist.unitname.includes(this.keyword)) &&
            maillist.statemsg == this.state &&
            maillist.createType == this.createType &&
            maillist.createTime >= this.time[0] &&
            maillist.createTime <= this.time[1]
        );
      } else if (
        this.time[0] != "" &&
        this.time[1] != "" &&
        this.state == "" &&
        this.createType != ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            (maillist.mail.includes(this.keyword) ||
              maillist.name.includes(this.keyword) ||
              maillist.unitname.includes(this.keyword)) &&
            maillist.createType == this.createType &&
            maillist.createTime >= this.time[0] &&
            maillist.createTime <= this.time[1]
        );
      } else {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail.includes(this.keyword) ||
            maillist.name.includes(this.keyword) ||
            maillist.unitname.includes(this.keyword)
        );
      }
    },
    tableData() {
      return this.allData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    }
  },
  components: {},
  async created() {
    // this.config.accountlist = await this.fetchData();
  },
  methods: {
    async CreateReport() {
      try {
        await this.$confirm("确定生成网易企业邮箱列表,确认?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        });
        this.loading = true;
        this.downloading = true;
        this.config.accountlist = await this.fetchData();
        this.loading = false;
        this.downloading = false;
        // eslint-disable-next-line no-empty
      } catch {
        this.loading = false;
        return;
      }
    },
    handleView(row) {
      this.viewData = row;
      this.viewShow = true;
    },
    async fetchData() {
      try {
        let response = await Emaillist.LIST();

        if (response.data.state) {
          this.loading = false;
          return response.data.accountlist;
        } else {
          this.loading = false;
          this.emptyText = "接口异常, 无法获取数据";
          return [];
        }
      } catch (e) {
        this.loading = false;
        this.$message.error("邮箱列表获取失败.");
      }
      return [];
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    createExcel() {
      let excel = [["邮箱", "姓名", "部门", "状态", "创建时间", "创建类型"]];
      this.allData.forEach(row =>
        excel.push([
          row.mail,
          row.name,
          row.unitname,
          row.statemsg,
          row.createTime,
          row.createType
        ])
      );
      return excel;
    },
    async exportExcel() {
      if (!this.downloading) {
        this.downloading = true;
        let loading = this.$loading({
          lock: true,
          text: "本地邮箱列表下载中, 请稍后!",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        try {
          /*  let res = await this.$http.post("genexcel", this.createExcel(), {
            responseType: "blob"
          });
           */
          let res = await UTIL.GENEXCEL(this.createExcel());
          let a = document.createElement("a");
          a.download = "邮箱列表.xlsx";
          a.href = URL.createObjectURL(res.data);
          a.click();
          loading.close();
        } catch (e) {
          this.$message.error("邮箱列表导出失败。");
        } finally {
          this.downloading = false;
          loading.close();
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-input {
  width: 200px;
  margin: 0 8px;
}
.custom-dialog {
  table {
    width: 100%;
    tr {
      line-height: 36px;
      td:first-child {
        width: 70px;
      }
    }
  }
}
</style>
